import React from 'react';
import NavDrawer from './NavDrawer';

// material components
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import { Link } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
}));

const ButtonAppBar = () => {
	// state management
  const classes = useStyles();
	const [openDrawer, setOpenDrawer] = React.useState(false);

  return (
    <>
		<div className={classes.root}>
      <AppBar position="static">
        <Toolbar>
          <IconButton onClick={() => setOpenDrawer(true)} edge="start" className={classes.menuButton} color="inherit" aria-label="menu">
            <MenuIcon/>
          </IconButton>
          <Typography variant="h6" className={classes.title}>
            Accredhospi-Bénin
          </Typography>
					<Link to='/infos' style={{ textDecoration: 'none', color: 'inherit' }}>
          	<Button color="inherit">Informations générales</Button>
					</Link>
        </Toolbar>
      </AppBar>
			{/* <Toolbar /> */}
    </div>
		<NavDrawer openDrawer={openDrawer} setOpenDrawer={setOpenDrawer} />
		</>
  );
}

export default ButtonAppBar;